export interface PowerRankingRowData {
  teamName: string;
  winPctg: number | undefined;
  winPctgRank: number
  winPctgAgainstMedian: number | undefined;
  winPctgAgainstMedianRank: number;
  totalPoints: number;
  totalPointsRank: number;
  totalOptimalPoints: number;
  totalOptimalPointsRank: number;
  optimalPointsDiff: number;
  optimalPointsDiffPctg: number | undefined;
  coachRank: number;
  powerPoints: number;
  powerRank: number;
}

export interface ChartDataPoint {
  name: string;
  shortName: string;
  fullName: string;
  powerRank: number;
  winPct: number;
  totalPoints: number;
  coachingEfficiency: number;
  optimalPoints: number;
  actualPoints: number;
  pointsLeft: number;
  wins: number;
  losses: number;
  ties: number;
  winPctgRank: number;
  pointsRank: number;
  coachRank: number;
  color: string;
  teamData: {
    picture?: string;
    fullName: string;
    shortName: string;
  };
}

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#FF7C7C', '#8DD1E1', '#D084D0'];

export const rank = function(data: PowerRankingRowData[], attrName: string, rankAttrName: string, desc: boolean) {
  var rank = 1;
  var currentValue = -1;
  var teamsAtRank = 0;
  data.sort((team1, team2) => {
    const team1Value = team1[attrName] ?? -1;
    const team2Value = team2[attrName] ?? -1;
    if (desc) {
      return team2Value - team1Value;
    }
    return team1Value - team2Value
  }).forEach(team => {
    const value = team[attrName] ?? -1;
    if (value === currentValue) {
      teamsAtRank++;
    } else {
      currentValue = value
      rank += teamsAtRank ?? 1
      teamsAtRank = 1;
    }
    team[rankAttrName] = rank
  });
}

export function a11yProps(index: number) {
  return {
    id: `power-rankings-tab-${index}`,
    'aria-controls': `power-rankings-tabpanel-${index}`,
  };
}
